"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isRTL = void 0;
// eslint-disable-next-line import/prefer-default-export
const isRTL = () => {
  if (typeof window === 'object') {
    return document.dir === 'rtl';
  }
  return false;
};
exports.isRTL = isRTL;